// extracted by mini-css-extract-plugin
module.exports = {"c1c9ky89":"c1c9ky89","c1nwe5wg":"c1nwe5wg","s1ixne2q":"s1ixne2q","s3buwzk":"s3buwzk","dot":"dot","divide":"divide","t17u3qep":"t17u3qep"};